import { observer } from 'mobx-react-lite'
import React from 'react'
import { Alert, SpinnerLoader } from 'shared/ui'
import { LINK_AUTH_APP } from 'shared/constants/links'
import type { TwoFaModalStore } from 'entities/Auth/ui/TwoFaModal'
import styles from './styles.module.scss'

export const QRCodeContent = observer(({ store }: { store: TwoFaModalStore }) => {
  const { qrCodeUrl } = store
  return (
    <div className={styles.qrWrap}>
      <Alert
        item={{
          type: 'infoLight',
          desc: 'Scan the QR code using the authenticator app',
        }}
        rightActions={[
          {
            variant: 'link',
            type: 'primary',
            text: 'Learn more',
            link: LINK_AUTH_APP,
          },
        ]}
      />

      <div className={styles.imageWrapper}>
        {qrCodeUrl ? (
          <img src={qrCodeUrl} alt='QR Code' className={styles.qrImage} />
        ) : (
          <SpinnerLoader ariaLabel={'QrCodeLoader'} size={20} />
        )}
      </div>
    </div>
  )
})
